addEventListener("DOMContentLoaded", () => {
  const body = document.querySelector("body");
  const popup = document.querySelector("#simulador__popup");
  const closePopup = document.querySelector("#simulador__close");
  const openPopup = document.querySelector("#simulador__open");

  openPopup.addEventListener("click", () => {
    body.style.overflow = "hidden";
    popup.classList.add("active");
  });

  closePopup.addEventListener("click", () => {
    body.style.overflow = "auto";
    popup.classList.remove("active");
  });

  document.addEventListener("keyup", (event) => {
    if (event.code.toUpperCase() === "ESCAPE") {
      body.style.overflow = "auto";
      popup.classList.remove("active");
    }
  });

  document.addEventListener("click", (event) => {
    if (event.target === popup) {
      body.style.overflow = "auto";
      popup.classList.remove("active");
    }
  });

  document.querySelectorAll(".item").forEach((item) => {
    const img = item.querySelector(".img__wrapper img");
    const titleSpan = item.querySelector(".title span");
    const buttons = item.querySelectorAll(".button__wrapper button");

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        // Remove classe 'active' de todos os botões deste bloco
        buttons.forEach((btn) => btn.classList.remove("active"));

        // Adiciona classe 'active' ao botão clicado
        button.classList.add("active");

        // Pega apenas a parte variável G50, G35, etc.
        const option = button.dataset.img.split("-")[1];

        // Substitui apenas a parte final da imagem mantendo o restante do caminho
        const srcParts = img.src.split("-");
        srcParts[srcParts.length - 1] = `${option}.jpg`;
        img.src = srcParts.join("-");

        // Atualiza o alt da imagem
        img.alt = `Película ${option}`;
      });
    });
  });
  
  // // Move o botão
  function moveButton() {
    const button = document.querySelector("#simuladorTransp");
    const buttonLocation = document.querySelector(".variant__wrapper-content");

    if (button && buttonLocation) {
      buttonLocation.appendChild(button);
      return true;
    }
    return false;
  }

  const observer = new MutationObserver(() => {
    if (moveButton()) {
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});
